<template>
    <div class="printAffirmOrderBox">
        <div class="addressInformation">
            <div class="title">
                <div class="titleLeft">收货信息</div>
                <!--<div class="titleRight">
                    <el-button type="text">地址管理</el-button>
                </div>-->
            </div>
            <div class="addressList">
                <div :class="item.checked?'active addressItem':'addressItem'" v-for="(item,index) in addressList" :key="index">
                    <el-checkbox class="checkBox" v-model="item.checked" @change="addressChecked(item)"></el-checkbox>
                    <div class="name">{{item.receiverName}} <el-button v-if="item.checked" type="text" icon="el-icon-edit" style="padding: 0;position: relative;z-index: 9;" @click="toEditAddress(item)"></el-button></div>
                    <div class="tel">{{item.mobile}}</div>
                    <div class="address">{{ item.province }}{{ item.city }}{{ item.district }}{{ item.areaInfo }}</div>
                    <img v-if="item.checked" src="@/assets/addressBorder.png" class="addressBorder">
                </div>
                <div class="addressItem addItem" @click="toDeliveryAddress">
                    <div class="icon"><i class="el-icon-plus"></i></div>
                    <div class="addName">新增地址</div>
                </div>
            </div>
        </div>
        <div class="orderInformation">
            <div class="title">
                <div class="titleLeft">订单信息</div>
                <div class="titleRight">
                    <!-- <el-button type="text" icon="el-icon-warning-outline">价格说明</el-button> -->
                </div>
            </div>
            <div class="informationContent">
                <div class="tableHeader">
                    <div class="modelFile">模型文件</div>
                    <div class="printInfo">打印信息</div>
                    <div class="facilitator">服务商</div>
                    <div class="price">单价</div>
                    <div class="printNum">打印数量</div>
                </div>
                <div class="tableContent">
                    <div class="modelFile">
                        <div style="display: block;">
                            <div v-for="(item,index) in form.technologyList" :key="index" style="display: flex;margin-bottom: 30px;justify-content: center;">
                                <div class="modelImg">
                                    <img class="snapshot" v-if="base64img" :src="base64img" />
                                    <model-stl ref="model" v-if="item.url.substr(item.url.lastIndexOf('.') + 1) == 'stl'" :src="item.url"  :rotation="rotation"></model-stl>
                                    <model-obj ref="model" v-if="item.url.substr(item.url.lastIndexOf('.') + 1) == 'obj'" :src="item.url"  :rotation="rotation"></model-obj>
                                    <!-- <model-stl ref="model" :src="item.url"  :rotation="rotation"></model-stl> -->
                                    <div class="model" @click="previewThreeD(item)">
                                        <i class="el-icon-zoom-in"></i>
                                    </div>
                                </div>
                                <div class="modelInfo">
                                    <div class="modelName" :title="item.name">{{item.name}}</div>
                                    <div class="size">尺寸：{{item.longSize}}*{{item.widthSize}}*{{item.heightSize}}cm</div>
                                    <div class="volume">体积：{{item.volume}} c㎥</div>
                                    <div class="zoom">缩放：{{item.scale}}%</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="printInfo">
                        <div>
                             <div class="printInfoItem">
                            <span>打印工艺：</span>
                            {{form.technologyName}}
                        </div>
                        <div class="printInfoItem">
                            <span>打印材料：</span>
                            {{form.materialName}}
                        </div>
                        <div class="printInfoItem">
                            <span>空心：</span>
                            {{form.soildUuid=='YES'?'是':'否'}}
                        </div>
                        <div class="printInfoItem">
                            <div>后处理：</div>
                            {{form.isReprocess=='YES'?'是':'否'}}
                        </div>
                        <div class="printInfoItem" v-if="form.isReprocess=='YES'">
                            <span>后处理类型：</span>
                            {{form.typeName}}
                        </div>
                        <div class="printInfoItem" v-if="form.isReprocess=='YES'">
                            <span>表面效果：</span>
                            {{form.surfaceEffectName}}
                        </div>
                        <div class="printInfoItem" v-if="form.isReprocess=='YES'" style="display:flex">
                            <span>备注：</span>
                            <div style="width:200px">{{form.printContent}}</div>
                        </div>
                        <div class="printInfoItem" v-if="form.isReprocess=='YES'">
                            <span>说明文件：</span>
                            <div class="content" style="width:50%">
                                <ul class="contentUi"> 
                                    <li v-for="(item,index) in form.fileList" :key="index">{{item.fileName}}</li>
                                </ul>
                            </div>
                        </div>
                        </div>
                       
                    </div>
                    <div class="facilitator">
                        <div>
                             <div class="facilitatorItem">
                                <span>服务商：</span>
                                {{facilitator.storeName}}
                            </div>
                            <div class="facilitatorItem" v-if="facilitator.managerList">
                                <span>材料：</span>
                            {{facilitator.managerList[0].materialName}}
                            </div>
                            <div class="facilitatorItem" v-if="facilitator.managerList">
                                <span>价格：</span>
                                {{facilitator.managerList[0].unitPrice}}元/克
                            </div>
                            <div class="facilitatorItem" v-if="facilitator.managerList">
                                <span>预计发货时间：</span>
                                {{facilitator.managerList[0].sendCycleMin}}-{{facilitator.managerList[0].sendCycleMax}}天
                            </div>
                        </div>
                       
                    </div>
                    <div class="price">
                        <div v-for="(item,index) in form.technologyList" :key="index" style="color: #E42424;line-height: 97px;">¥ {{item.unitPrice}}</div>
                    </div>
                    <div class="printNum">
                        <div v-for="(item,index) in form.technologyList" :key="index"  style="line-height: 97px;">{{item.printNum}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="invoiceInformation">
            <div class="title">
                <div class="titleLeft">发票信息</div>
            </div>
            <div class="invoiceContent">
                <div class="default" v-if="JSON.stringify(invoiceInfo)=='{}'">
                    <div class="invoiceItem">
                        <div class="name">发票信息：</div>
                        <div>
                            <el-button type="text" icon="el-icon-edit" @click="selectInvoice"></el-button>
                        </div>
                    </div>
                </div>
                <div class="default" v-if="invoiceInfo.activeName=='DZFP'">
                    <div class="invoiceItem">
                        <div class="name">发票信息：</div>
                        <div>
                            <span>{{ invoiceInfo.name  }}</span>
                            <span>{{ invoiceInfo.type }}</span>
                            <el-button type="text" icon="el-icon-edit" @click="selectInvoice"></el-button>
                        </div>
                    </div>
                </div>
                <div class="invoiceInfo" v-if="invoiceInfo.activeName=='ZZFP'">
                    <div class="invoiceItem">
                        <div class="name">发票信息：</div>
                        <div>
                            <div class="content">
                                <span>{{ invoiceInfo.name }}</span>
                                <span>{{invoiceInfo.type}}</span>
                                <el-button type="text" icon="el-icon-edit" @click="selectInvoice" style="padding: 0;"></el-button>
                            </div>
                            <div class="content"><span>发票抬头: {{invoiceInfo.title}}</span></div>
                            <div class="content" v-if="invoiceInfo.code"><span>税号: {{invoiceInfo.code}}</span></div>
                            <div class="content" v-if="invoiceInfo.bank"><span>开户银行: {{invoiceInfo.bank}}</span></div>
                            <div class="content" v-if="invoiceInfo.bankAccount"><span>银行账号: {{invoiceInfo.bankAccount}}</span></div>
                            <div class="content" v-if="invoiceInfo.address"><span>注册地址: {{invoiceInfo.address}}</span></div>
                            <div class="content" v-if="invoiceInfo.mobile"><span>注册电话: {{invoiceInfo.mobile}}</span></div>
                        </div>
                    </div>
                </div>
                <div class="invoiceInfo" v-if="invoiceInfo.activeName=='DZFP'">
                    <div class="invoiceItem">
                        <div class="name">收票邮箱：</div>
                        <div>
                            <div class="content"><span>{{invoiceInfo.email}}</span></div>
                        </div>
                    </div>
                </div>
                <div class="invoiceInfo" v-if="invoiceInfo.activeName=='ZZFP'">
                    <div class="invoiceItem">
                        <div class="name">收票地址：</div>
                        <div>
                            <div class="content"><span>收票人: {{invoiceInfo.receiverName}}</span></div>
                            <div class="content"><span>收票电话: {{invoiceInfo.mobile1}}</span></div>
                            <div class="content"><span>收票地址: {{invoiceInfo.payeeAddress}}</span></div>
                        </div>
                    </div>
                </div>
                <div class="remark">
                    <div class="name">备注：</div>
                    <el-input v-model="form.remark" placeholder="备注信息" style="width: 500px;"></el-input>
                </div>
            </div>
        </div>
        <div class="toAffirmOrder">
            <div class="subtotal">
                <div class="name">小计：</div>
                <div class="content">¥{{ sumPrice }}</div>
            </div>
            <div class="freight">
                <div class="left">
                    <el-checkbox v-model="printNotice">请阅读后勾选 <span @click="dialogVisible = true">《我要打印购买须知》</span></el-checkbox>
                </div>
                <div class="right">
                    <div class="name">运费：</div>
                    <div class="content">¥ {{ transportationPrice }}</div>
                </div>
            </div>
            <div class="total">
                <div class="content" v-if="sumPrice>0" style="color:#E42424;font-size: 12px">系统报价仅供参考，最终报价以服务商确认为准！</div>
                <div class="content" v-else  style="color:#E42424;font-size: 12px">该模型无法自动计算价格，请与服务商沟通确认最终报价</div>
            </div>
            <div class="total">
                <div class="name">合计 <span>（含运费）</span>：</div>
                <div class="content">¥ {{ totalPrice }}</div>
            </div>
            <div class="buttonGroup">
                <el-button @click="$router.go(-1)">取消</el-button>
                <el-button type="primary" @click="submitOrder">确认订单</el-button>
            </div>
        </div>
        
        <!--新增/编辑地址-->
        <delivery-address-dialog ref="deliveryAddressDialogRef" @address="deliveryAddress"></delivery-address-dialog>
        <!--发票抬头列表-->
        <invoice-title-dialog ref="invoiceTitleDialogRef" @selectInvoice="selectInvoiceValue"></invoice-title-dialog>
        <!-- 3D预览 -->
        <three-d
                ref="threeBox"
                :innerVisible="innerVisible"
                :fileListNew="fileListNew"
                @closeDlog="closeDlog"
        ></three-d>
        <!-- 协议 -->
        <el-dialog
                title="我要打印购买须知"
                center
                :visible.sync="dialogVisible"
                width="900px">
            <el-scrollbar style="height: 600px">
                <div v-html="content" class="vHtmlMess"></div>
            </el-scrollbar>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button type="primary" @click="dialogVisible = false">同意服务条款</el-button> -->
                <el-button type="primary" @click="agree()">同意服务条款</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import deliveryAddressDialog from './deliveryAddressDialog'
import invoiceTitleDialog from './invoiceTitleDialog'
import threeD from "../threeD/index";
import { ModelStl, ModelObj } from "vue-3d-model";
import { findBuyerPrintOrderDetail,getAddressList,savePrintOrder,
    getOrderPrint,saveOrderPrint,saveIssueInvoiceByUuid,getInfoByWordNo,
    getManagerProvidersInfo,getDictionaryGroupByKey,getLogisticsInfo, get } from '../../utils/interface';
export default {
    name: "printAffirmOrder",
    data(){
        return{
            checked: false,
            addressList: [],
            remarkValue: '',
            printNotice: false,
            invoiceInfo: {},
            printOrderUuid:"",
            facilitator:"",
            form:{},
            sumPrice:0,
            totalPrice:0,
            transportationPrice:0,
            receipt:{},
            logisticsUuid:"",
            addressInfo:"",
            province:"",
            city:"",
            district:"",
            sumWeight:0,
            base64img:"",
            rotation: {
                // x: -Math.PI / 2,
                x: 200,
                y: 0,
                z: 100,
            },
            innerVisible:false,
            fileListNew:[],
            orderBase:"",
            invoiceIssue:{},
            content:"",
            dialogVisible:false,
        }
    },
    mounted(){
        this.snapshot()
    },
    components: {
        deliveryAddressDialog,
        invoiceTitleDialog,
        threeD,
        ModelStl,
        ModelObj
    },
    created(){
        getInfoByWordNo({"wordNo":"DYXZ"}).then((res)=>{
            if(res&&res.data){
                this.content = res.data.content;
            }
        });
        this.printOrderUuid = this.$route.params.printOrderUuid;
        this.findBuyerPrintOrderDetail();
        this.getAddressList();
        this.invoiceInfo = {};
        // 查询订单信息
        getOrderPrint({printOrderUuid:this.printOrderUuid}).then((res)=>{
            this.orderBase = res.orderBase;
        });
    },
    methods: {
        agree(){
            this.printNotice=true;
            this.dialogVisible=false
        },
        // 预览3D模型
        previewThreeD(item) {
            this.$refs.threeBox.threeAnimal(item);
            this.innerVisible = true;
        },
        closeDlog(index) {
            this.innerVisible = index;
        },
        snapshot() {
            this.base64img = this.$refs.model[0].renderer.domElement.toDataURL('image/png', 1);
        },
        getAddressList(){
            getAddressList().then((res) => {
                res.data.map(item => {
                    if(item.defaultVal == 1){
                        item.checked = true;
                        this.form.takeOverUuid = item.uuid;
                        this.getAddressInfo(item);
                    }else {
                        item.checked = false;
                    }
                });
                this.addressList = res.data;
            });
        },
        getAddressInfo(item){
            // 省市县
            if(item.province!=null&&item.province!=item.city){
                this.province = item.province.replace('省','');
                this.addressInfo += "," + item.province.replace('省','');
            }else if(item.province!=null&&item.province==item.city){
                this.province = item.province.replace('市','');
                this.addressInfo += "," + item.province.replace('市','');
            }
            if(item.city!=null&&item.province!=item.city){
                this.city = this.province + "," + item.city.replace('市','');
                this.addressInfo += "," + item.city.replace('市','');
            }
            if(item.district!=null){
                this.district = item.district;
                this.addressInfo += "," + item.district;
            }
            this.addressInfo = this.addressInfo.substring(1);
        },
        findBuyerPrintOrderDetail(){
            let params = {
                uuid:this.printOrderUuid
            };
            findBuyerPrintOrderDetail(params).then((res)=> {
                if(res.data.technologyList.length>0){
                    res.data.technologyList.map(item=>{
                        this.sumWeight = Number(this.sumWeight) + Number(item.weightModel);
                        this.sumPrice = Number(this.sumPrice)+Number(Number(item.unitPrice)*Number(item.printNum));
                    });
                }
                //
                if(res.data.materialUuid!=null){
                    get({uuid:res.data.materialUuid}).then((res)=>{
                        if(res&&res.data){
                            this.form.materialName = res.data.name;
                        }
                    });
                }
                this.form = res.data;
                getManagerProvidersInfo({materialManagerUuid: res.data.materialManagerUuid}).then((res) => {
                    this.facilitator = res.data;
                    // 计算物流
                    this.getLogisticsInfo(this.facilitator);
                });
                // 获取参数
                if(res.data.typeUuid!='') {
                    getDictionaryGroupByKey({uuid: res.data.typeUuid}).then((res) => {
                        this.form.typeName = res.name;
                    });
                }
                // 发票信息
            });
        },
        getLogisticsInfo(itemInfo){
            console.log(this.form);
            if(itemInfo.managerList[0].isTransportation=="YES") {
                if(this.province!=""&&this.city!=""&&this.district!="") {
                    this.logisticsUuid = itemInfo.managerList[0].logisticsUuid;
                    getLogisticsInfo({uuid: this.logisticsUuid}).then((res) => {
                        let isFlag = true;
                        if (res.success) {
                            // 先判断当前区域是否存在免费区域内
                            if (res.data.freeArea != null) {
                                if (res.data.freeArea == "全国") {
                                    this.transportationPrice = 0;
                                } else if (res.data.freeArea.indexOf(this.province) != -1) {
                                    this.transportationPrice = 0;
                                    // 市
                                    if (res.data.freeArea.indexOf(this.city) != -1) {
                                        // 如果省市存在，省市县不存在则按照省市来算。
                                        this.transportationPrice = 0;
                                        // 区域
                                        if (res.data.freeArea.indexOf(this.district) != -1) {
                                            isFlag = false;
                                            this.transportationPrice = 0;
                                        } else {
                                            this.transportationPrice = 0;
                                        }
                                    }
                                }
                            }
                            // 按件
                            if (isFlag) {
                                let itemList = res.data.details;
                                if (res.data.chargeMode == "piece") {
                                    if (this.sumPrice == 0) {
                                        this.sumPrice = Number(this.sumPrice).toFixed(2);
                                        this.totalPrice = Number(this.sumPrice) + Number(this.transportationPrice);
                                        this.totalPrice = Number(this.totalPrice).toFixed(2);
                                    } else {
                                        if (itemList.length > 0) {
                                            for (let i = 0; i < itemList.length; i++) {
                                                // 如果是全国直接计算
                                                if (itemList[i].area.indexOf("全国") != -1) {
                                                    if (this.form.goodsNum > itemList[i].firstHeavy) {
                                                        // 首件是默认的运费
                                                        this.transportationPrice = itemList[i].freight;
                                                        // 续件运费
                                                        let num = Math.ceil((Number(this.form.goodsNum) - Number(itemList[i].firstHeavy)) / itemList[i].continuedHeavy);
                                                        this.transportationPrice = this.transportationPrice + Number(num * itemList[i].renew);
                                                    } else {
                                                        this.transportationPrice = itemList[i].freight;
                                                    }
                                                } else if (itemList[i].area.indexOf(this.province) != -1) {
                                                    // 如果省市存在，省市县不存在则按照省市来算。
                                                    if (this.form.goodsNum > itemList[i].firstHeavy) {
                                                        // 首件是默认的运费
                                                        this.transportationPrice = itemList[i].freight;
                                                        // 续件运费
                                                        let num = Math.ceil((Number(this.form.goodsNum) - Number(itemList[i].firstHeavy)) / itemList[i].continuedHeavy);
                                                        this.transportationPrice = this.transportationPrice + Number(num * itemList[i].renew);
                                                    } else {
                                                        this.transportationPrice = itemList[i].freight;
                                                    }
                                                    // 市
                                                    if (itemList[i].area.indexOf(this.city) != -1) {
                                                        if (this.form.goodsNum > itemList[i].firstHeavy) {
                                                            // 首件是默认的运费
                                                            this.transportationPrice = itemList[i].freight;
                                                            // 续件运费
                                                            let num = Math.ceil((Number(this.form.goodsNum) - Number(itemList[i].firstHeavy)) / itemList[i].continuedHeavy);
                                                            this.transportationPrice = this.transportationPrice + Number(num * itemList[i].renew);
                                                        } else {
                                                            this.transportationPrice = itemList[i].freight;
                                                        }
                                                        // 区域
                                                        if (itemList[i].area.indexOf(this.district) != -1) {
                                                            // 省市县都存在，就按照省市县来算
                                                            // 如果省市存在，省市县不存在则按照省市来算。
                                                            if (this.form.goodsNum > itemList[i].firstHeavy) {
                                                                // 首件是默认的运费
                                                                this.transportationPrice = itemList[i].freight;
                                                                // 续件运费
                                                                let num = Math.ceil((Number(this.form.goodsNum) - Number(itemList[i].firstHeavy)) / itemList[i].continuedHeavy);
                                                                this.transportationPrice = this.transportationPrice + Number(num * itemList[i].renew);
                                                            } else {
                                                                this.transportationPrice = itemList[i].freight;
                                                            }
                                                            break;
                                                        } else {
                                                            // 如果省市存在，省市县不存在则按照省市来算。
                                                            if (this.form.goodsNum > itemList[i].firstHeavy) {
                                                                // 首件是默认的运费
                                                                this.transportationPrice = itemList[i].freight;
                                                                // 续件运费
                                                                let num = Math.ceil((Number(this.form.goodsNum) - Number(itemList[i].firstHeavy)) / itemList[i].continuedHeavy);
                                                                this.transportationPrice = this.transportationPrice + Number(num * itemList[i].renew);
                                                            } else {
                                                                this.transportationPrice = itemList[i].freight;
                                                            }
                                                        }
                                                        break;
                                                    }
                                                }
                                            }
                                            this.sumPrice = Number(this.sumPrice).toFixed(2);
                                            this.totalPrice = Number(this.sumPrice) + Number(this.transportationPrice);
                                            this.totalPrice = Number(this.totalPrice).toFixed(2);
                                        }
                                    }
                                } else if (res.data.chargeMode == "weight") {
                                    // 重量计算
                                    if (this.sumWeight == 0) {
                                        this.sumPrice = Number(this.sumPrice).toFixed(2);
                                        this.totalPrice = Number(this.sumPrice) + Number(this.transportationPrice);
                                        this.totalPrice = Number(this.totalPrice).toFixed(2);
                                    } else {
                                        if (itemList.length > 0) {
                                            for (let i = 0; i < itemList.length; i++) {
                                                if (itemList[i].area.indexOf("全国") != -1) {
                                                    if (this.sumWeight > itemList[i].firstHeavy) {
                                                        // 首件是默认的运费
                                                        this.transportationPrice = itemList[i].freight;
                                                        // 续件运费
                                                        let num = Math.ceil((Number(this.sumWeight) - Number(itemList[i].firstHeavy)) / itemList[i].continuedHeavy);
                                                        this.transportationPrice = this.transportationPrice + Number(num * itemList[i].renew);
                                                    } else {
                                                        this.transportationPrice = itemList[i].freight;
                                                    }
                                                } else if (itemList[i].area.indexOf(this.province) != -1) {
                                                    if (this.sumWeight > itemList[i].firstHeavy) {
                                                        // 首件是默认的运费
                                                        this.transportationPrice = itemList[i].freight;
                                                        // 续件运费
                                                        let num = Math.ceil((Number(this.sumWeight) - Number(itemList[i].firstHeavy)) / itemList[i].continuedHeavy);
                                                        this.transportationPrice = this.transportationPrice + Number(num * itemList[i].renew);
                                                    } else {
                                                        this.transportationPrice = itemList[i].freight;
                                                    }
                                                    if (itemList[i].area.indexOf(this.city) != -1) {
                                                        if (this.sumWeight > itemList[i].firstHeavy) {
                                                            // 首件是默认的运费
                                                            this.transportationPrice = itemList[i].freight;
                                                            // 续件运费
                                                            let num = Math.ceil((Number(this.sumWeight) - Number(itemList[i].firstHeavy)) / itemList[i].continuedHeavy);
                                                            this.transportationPrice = this.transportationPrice + Number(num * itemList[i].renew);
                                                        } else {
                                                            this.transportationPrice = itemList[i].freight;
                                                        }
                                                        if (itemList[i].area.indexOf(this.district) != -1) {
                                                            if (this.sumWeight > itemList[i].firstHeavy) {
                                                                // 首件是默认的运费
                                                                this.transportationPrice = itemList[i].freight;
                                                                // 续件运费
                                                                let num = Math.ceil((Number(this.sumWeight) - Number(itemList[i].firstHeavy)) / itemList[i].continuedHeavy);
                                                                this.transportationPrice = this.transportationPrice + Number(num * itemList[i].renew);
                                                            } else {
                                                                this.transportationPrice = itemList[i].freight;
                                                            }
                                                            break;
                                                        } else {
                                                            if (this.sumWeight > itemList[i].firstHeavy) {
                                                                // 首件是默认的运费
                                                                this.transportationPrice = itemList[i].freight;
                                                                // 续件运费
                                                                let num = Math.ceil((Number(this.sumWeight) - Number(itemList[i].firstHeavy)) / itemList[i].continuedHeavy);
                                                                this.transportationPrice = this.transportationPrice + Number(num * itemList[i].renew);
                                                            } else {
                                                                this.transportationPrice = itemList[i].freight;
                                                            }
                                                        }
                                                        break;
                                                    }
                                                }
                                            }
                                            this.sumPrice = Number(this.sumPrice).toFixed(2);
                                            this.totalPrice = Number(this.sumPrice) + Number(this.transportationPrice);
                                            this.totalPrice = Number(this.totalPrice).toFixed(2);
                                        }
                                    }
                                }
                            }
                        }
                    });
                }else{
                    this.transportationPrice = 0;
                    this.sumPrice = Number(this.sumPrice).toFixed(2);
                    this.totalPrice = Number(this.sumPrice) + Number(this.transportationPrice);
                    this.totalPrice = Number(this.totalPrice).toFixed(2);
                }
            }else{
                this.transportationPrice = 0;
                this.sumPrice = Number(this.sumPrice).toFixed(2);
                this.totalPrice = Number(this.sumPrice) + Number(this.transportationPrice);
                this.totalPrice = Number(this.totalPrice).toFixed(2);
            }
        },
        // 地址选中事件
        addressChecked(val){
            this.addressList.map(item=>{
                if(item.uuid === val.uuid){
                    item.checked = val.checked;
                    this.getAddressInfo(item);
                } else {
                    item.checked = false
                }
            });
            this.form.takeOverUuid = val.uuid;
            // 计算物流
            this.getLogisticsInfo(this.facilitator);
        },
        // 点击打开新增地址弹出框
        toDeliveryAddress(){
            this.$refs.deliveryAddressDialogRef.init('add')
        },
        // 新增/修改地址
        deliveryAddress(val){
            getAddressList().then((res) => {
                res.data.map(item => {
                    if(val.uuid==item.uuid) {
                        item.checked = true;
                    }else{
                        item.checked = false;
                    }
                });
                this.addressList = res.data;
            });
        },
        // 点击打卡编辑地址弹出框
        toEditAddress(item){
            this.$refs.deliveryAddressDialogRef.init('edit',item)
        },
        // 点击打开选择发票
        selectInvoice(){
            // 如果有数据就回显，没有就算了
            let params = {
                uuid:'',
                orderUuid:this.orderBase.uuid,
                orderNo:this.orderBase.orderNo,
                orderName:this.form.technologyList[0].name,
                orderImg:this.form.technologyList[0].url,
                orderType:'PRINT',
                issueUser:this.form.userUuid,
                invoiceMoney:this.form.totalPrice,
                invoiceType:this.invoiceInfo.activeName,
                invoiceUuid:this.invoiceInfo.uuid,
                payeeUuid:this.invoiceInfo.payeeUuid,
                invoiceStatus:"EXAMINE",
            };
            this.invoiceIssue = params;
            this.$refs.invoiceTitleDialogRef.init(this.invoiceIssue);
        },
        // 获取选中发票信息
        selectInvoiceValue(invoice){
            this.invoiceIssue.invoiceType = invoice.activeName;
            this.invoiceIssue.invoiceUuid = invoice.uuid;
            this.invoiceIssue.payeeUuid = invoice.payeeUuid;
            this.invoiceIssue.issueType = invoice.activeName;
            this.invoiceInfo = invoice;
        },
        // 确认订单
        submitOrder(){
            this.form.goodsNum = this.orderBase.totalNum;
            //this.form.receipt = this.receipt;
            this.form.totalPrice = this.totalPrice;
            this.form.transportationPrice = this.transportationPrice;
            let addressSelected = this.addressList.filter(item => {
                return item.checked === true
            });
            if(addressSelected.length <= 0){
                this.$message.warning('请选择收货地址!')
            } else if(!this.printNotice){
                this.$message.warning('请勾选购买须知!')
            } else {
                // 保存价格
                savePrintOrder(this.form).then((res) => {
                    if(res.success) {
                        // 保存发票信息
                        if (this.invoiceIssue.invoiceUuid != undefined) {
                            saveIssueInvoiceByUuid(this.invoiceIssue).then((req) => {
                                if (req.success) {
                                    this.$message.success('保存成功');
                                    this.$router.push({
                                        name: 'printSendSuccess',
                                        params: {orderCode: res.data.orderCode,uuid: res.data.uuid}
                                    });
                                }
                            });
                        } else {
                            this.$message.success('保存成功');
                            this.$router.push({
                                name: 'printSendSuccess',
                                params: {orderCode: res.data.orderCode,uuid: res.data.uuid}
                            });
                        }
                    }
                });
                /*savePrintOrder(this.form).then((res)=>{
                    if(res.success) {
                        getOrderPrint({printOrderUuid:res.data.uuid}).then((result)=>{
                            let params = {};
                            if(result!=""){
                                result.totalNum = result.orderBase.totalNum;
                                result.totalPrice = this.totalPrice;
                                params = result;
                            }
                            saveOrderPrint(params).then((rest)=>{
                                if(rest.success){
                                    // 保存成功
                                    savePrintOrder(this.form).then((resl)=>{
                                        if(resl.success){
                                            // 保存发票信息
                                            if(this.invoiceIssue.invoiceUuid!=undefined) {
                                                saveIssueInvoiceByUuid(this.invoiceIssue).then((req) => {
                                                    if (req.success) {
                                                        this.$message.success('保存成功');
                                                        this.$router.push({
                                                            name: 'printSendSuccess',
                                                            params: {orderCode: res.data.orderCode}
                                                        });
                                                    }
                                                });
                                            }else{
                                                this.$message.success('保存成功');
                                                this.$router.push({
                                                    name: 'printSendSuccess',
                                                    params: {orderCode: res.data.orderCode}
                                                });
                                            }
                                        }
                                    });
                                }
                            });
                        });

                    }
                });*/
            }
        },
        threeAnimal(res) {
            let threeImgs = res.url;
            this.fileListNew.push(res.url);
            var w = 1000;
            var h = 396;

            var renderer;

            function initRender() {
                renderer = new THREE.WebGLRenderer({
                    antialias: true,
                });
                renderer.setSize(w, h);
                //告诉渲染器需要阴影效果
                renderer.setClearColor(0xffffff);
            }

            var camera;

            function initCamera() {
                camera = new THREE.PerspectiveCamera(45, w / h, 0.1, 1000);
                camera.position.set(0, 40, 50);
                camera.lookAt(new THREE.Vector3(0, 0, 0));
            }

            var scene;

            function initScene() {
                scene = new THREE.Scene();
            }

            //初始化dat.GUI简化试验流程
            var gui;

            function initGui() {
                //声明一个保存需求修改的相关数据的对象
                gui = {};
                var datGui = new dat.GUI();
                //将设置属性添加到gui当中，gui.add(对象，属性，最小值，最大值）
            }

            var light;

            function initLight() {
                scene.add(new THREE.AmbientLight(0x444444));

                light = new THREE.PointLight(0xffffff);
                light.position.set(0, 50, 50);

                //告诉平行光需要开启阴影投射
                light.castShadow = true;

                scene.add(light);
            }
            let that = this;
            function initModel() {
                //文件路径
                //获取最后一个.的位置
                var index = threeImgs.lastIndexOf(".");
                //获取后缀
                var ext = threeImgs.substr(index + 1);
                //辅助工具
                // var helper = new THREE.AxesHelper(50);
                // scene.add(helper);
                // 上传文件
                if (ext.toUpperCase() == "STL") {
                    that.loader = new THREE.STLLoader();
                } else if (ext.toUpperCase() == "OBJ") {
                    that.loader = new THREE.OBJLoader();
                }
                that.loader.load(threeImgs, function (geometry) {
                    if (ext.toUpperCase() == "OBJ") {
                        // //创建纹理
                        var mat = new THREE.MeshLambertMaterial({
                            color: 0x00ffff,
                        });
                        var mesh = new THREE.Mesh(geometry, mat);
                        console.log(
                            "new THREE.Box3()",
                            new THREE.Box3().setFromObject(mesh).size()
                        );
                        var boundingBox = new THREE.Box3().setFromObject(mesh).size();

                        // 查看加载器生成的材质对象：MeshPhongMaterial
                        console.log(geometry.children[0]);
                        scene.add(geometry);
                        // 加载后的一些编辑操作
                        geometry.children[0].scale.set(5, 5, 5); //网格模型缩放
                        geometry.children[0].geometry.center(); //网格模型的几何体居中
                        geometry.children[0].material.color.set(0x00ffff); //设置材质颜色

                        if ((boundingBox.x / 10).toFixed(2) > 50) {
                            mesh.scale.set(0.03, 0.03, 0.03); //缩放
                        } else if ((boundingBox.x / 10).toFixed(2) < 10) {
                            mesh.scale.set(0.5, 0.5, 0.5); //缩放
                        }
                    } else if (ext.toUpperCase() == "STL") {
                        if (geometry instanceof THREE.BufferGeometry) {
                            geometry = new THREE.Geometry().fromBufferGeometry(geometry);
                        }
                        //尺寸
                        geometry.computeBoundingBox();
                        // 计算体积
                        var volume = 0;
                        for (var f = 0, fl = geometry.faces.length; f < fl; f++) {
                            var face = geometry.faces[f];

                            var vA = geometry.vertices[face.a];
                            var vB = geometry.vertices[face.b];
                            var vC = geometry.vertices[face.c];

                            (that.x1 = vA.x), (that.x2 = vB.x), (that.x3 = vC.x);
                            (that.y1 = vA.y), (that.y2 = vB.y), (that.y3 = vC.y);
                            (that.z1 = vA.z), (that.z2 = vB.z), (that.z3 = vC.z);
                            let V =
                                (-that.x3 * that.y2 * that.z1 +
                                    that.x2 * that.y3 * that.z1 +
                                    that.x3 * that.y1 * that.z2 -
                                    that.x1 * that.y3 * that.z2 -
                                    that.x2 * that.y1 * that.z3 +
                                    that.x1 * that.y2 * that.z3) /
                                6;

                            volume += V / 1000;
                        }
                        console.log("体积：", volume.toFixed(2) + "cm3");

                        //创建纹理
                        var mat = new THREE.MeshLambertMaterial({
                            // color: 0x00ffff,
                            color: 0x00ffff,
                        });
                        var mesh = new THREE.Mesh(geometry, mat);
                        //console.log(mesh);

                        mesh.rotation.x = -0.5 * Math.PI; //将模型摆正
                        mesh.scale.set(0.5, 0.5, 0.5); //缩放
                        geometry.center(); //居中显示
                        scene.add(mesh);
                        // 长宽高
                        // 计算长宽高
                        var boundingBox = new THREE.Box3().setFromObject(mesh).size();
                        let lengthBox = ((boundingBox.x / 10) * 2).toFixed(2);
                        let heightBox = ((boundingBox.y / 10) * 2).toFixed(2);
                        let widthBox = ((boundingBox.z / 10) * 2).toFixed(2);
                        console.log(
                            "var box = new THREE.Box3().setFromObject( mesh );",
                            new THREE.Box3().setFromObject(mesh).size()
                        );
                        // 空心查询脱壳厚度
                        if (that.soildUuid) {
                            that.minValue = Number(lengthBox);
                            if (that.minValue > Number(widthBox)) {
                                that.minValue = Number(widthBox);
                                if (that.minValue > Number(heightBox)) {
                                    that.minValue = Number(heightBox);
                                }
                            } else if (that.minValue > Number(heightBox)) {
                                that.minValue = Number(heightBox);
                                if (that.minValue > Number(widthBox)) {
                                    that.minValue = Number(widthBox);
                                }
                            }
                        }
                    }
                });
            }

            //初始化性能插件
            var stats;

            function initStats() {
                stats = new Stats();
            }

            //用户交互插件 鼠标左键按住旋转，右键按住平移，滚轮缩放
            var controls;

            function initControls() {
                controls = new THREE.OrbitControls(camera, renderer.domElement);

                // 如果使用animate方法时，将此函数删除
                //controls.addEventListener( 'change', render );
                // 使动画循环使用时阻尼或自转 意思是否有惯性
                controls.enableDamping = true;
                //动态阻尼系数 就是鼠标拖拽旋转灵敏度
                //controls.dampingFactor = 0.25;
                //是否可以缩放
                controls.enableZoom = true;
                //是否自动旋转
                controls.autoRotate = true;
                controls.autoRotateSpeed = 0.5;
                //设置相机距离原点的最远距离
                controls.minDistance = 1;
                //设置相机距离原点的最远距离
                controls.maxDistance = 200;
                //是否开启右键拖拽
                controls.enablePan = true;
            }

            function render() {
                renderer.render(scene, camera);
            }

            //窗口变动触发的函数
            function onWindowResize() {
                camera.aspect = w / h;
                camera.updateProjectionMatrix();
                render();
                renderer.setSize(w, h);
            }

            function animate() {
                //更新控制器
                render();

                //更新性能插件
                stats.update();

                controls.update();

                requestAnimationFrame(animate);
            }

            function draw() {
                initGui();
                initRender();
                initScene();
                initCamera();
                initLight();
                initModel();
                initControls();
                initStats();
                animate();
                window.onresize = onWindowResize;
            }
            draw();
        },
    }
}
</script>

<style scoped lang="less">
    div {
        
        box-sizing: border-box;
    }
    
    .printAffirmOrderBox {
        background: #F0F2F5;
        padding: 90px 0 100px;
        .addressInformation{
            width: 1200px;
            margin: 0 auto 20px;
            background: #fff;
            border-radius: 2px;
            .title {
                width: 100%;
                height: 56px;
                line-height: 55px;
                border-bottom: 1px solid #F0F0F0;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 24px;
                .titleLeft {
                    font-size: 16px;
                    font-weight: 500;
                    color: rgba(0, 0, 0, 0.85);
                }
                .titleRight {
                    display: flex;
                    button {
                        margin-left: 50px;
                    }
                }
            }
            .addressList{
                padding: 24px 15px 0;
                display: flex;
                flex-wrap: wrap;
                .addressItem{
                    padding: 14px 22px;
                    margin-bottom: 24px;
                    margin-right: 30px;
                    position: relative;
                    width: 270px;
                    border-radius: 8px;
                    border: 2px dashed #E3E3E3;
                    font-size: 14px;
                    .addressBorder{
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 100%;
                    }
                    &.active{
                        border: 2px dashed #fff;
                    }
                    &:nth-of-type(4n){
                        margin-right: 0;
                    }
                    .checkBox{
                        position: absolute;
                        right: 22px;
                        top: 14px;
                    }
                    .name{
                        color: #000;
                    }
                    .tel{
                        color: rgba(51, 51, 51, 0.85);
                        padding: 6px 0;
                    }
                    .address{
                        color: rgba(51, 51, 51, 0.85);
                        line-height: 22px;
                    }
                }
                .addItem{
                    text-align: center;
                    cursor: pointer;
                    color: #666;
                    &:hover{
                        border: 2px dashed #1890FF;
                    }
                    .icon{
                        font-size: 30px;
                    }
                    .addName{
                        font-size: 14px;
                        padding-top: 5px;
                    }
                }
            }
        }
        .orderInformation{
            width: 1200px;
            margin: 0 auto 20px;
            background: #fff;
            border-radius: 2px;
            .title {
                width: 100%;
                height: 56px;
                line-height: 55px;
                border-bottom: 1px solid #F0F0F0;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 24px;
                .titleLeft {
                    font-size: 16px;
                    font-weight: 500;
                    color: rgba(0, 0, 0, 0.85);
                }
                .titleRight {
                    display: flex;
                    button {
                        margin-left: 50px;
                    }
                }
            }
            .informationContent{
                padding: 15px 24px;
                .tableHeader{
                    padding: 0 15px;
                    width: 100%;
                    background: #FAFAFA;
                    height: 54px;
                    line-height: 54px;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.85);
                    display: flex;
                }
                .tableContent{
                    display: flex;
                    align-items: center;
                    padding: 10px 15px;
                    font-size: 12px;
                    .modelFile{
                        text-align: left;
                        display: flex;
                        padding-right: 10px;
                        .modelImg{
                            width: 96px;
                            height: 96px;
                            position: relative;
                            &:hover {
                                .model {
                                    display: block;
                                }
                            }
                            img {
                                width: 96px;
                                height: 96px;
                                border: 1px solid rgba(0, 0, 0, 0.15);
                            }
                            .model {
                                position: absolute;
                                left: 0;
                                top: 0;
                                width: 98px;
                                height: 98px;
                                background: rgba(0, 0, 0, 0.3);
                                text-align: center;
                                line-height: 94px;
                                display: none;
                                i {
                                    color: #fff;
                                    cursor: pointer;
                                    font-size: 20px;
                                }
                            }
                        }
                        .modelInfo{
                            color: #666666;
                            .modelName{
                                color: #000000;
                                font-size: 14px;
                                padding-bottom: 12px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                width: 195px;
                            }
                            .volume{
                                padding: 9px 0;
                            }
                        }
                    }
                    .printInfo{
                            display: flex;
                            justify-content: center;
                        .printInfoItem{
                            display: flex;
                            // justify-content: center;
                            padding: 5px 0;
                            .contentUi{
                               
                                text-align: left;
                                li{
                                     width: 50%;
                                }
                            }
                            .name{
                                color: #737373;
                                min-width: 80px;
                                text-align: right;
                            }
                            .content{
                                color: #000;
                                ul{
                                    li{
                                        color: #409EFF;
                                        cursor: pointer;
                                    }
                                }
                            }
                        }
                    }
                    .facilitator{
                        display: flex;
                        justify-content: center;
                        .facilitatorItem{
                            display: flex;
                            // justify-content: center;
                            padding: 5px 0;
                            .name{
                                color: #737373;
                                min-width: 100px;
                                text-align: left;
                            }
                            .content{
                                color: #000;
                            }
                        }
                    }
                }
                .modelFile{
                    flex: 1;
                    text-align: center;
                }
                .printInfo{
                    width: 300px;
                    text-align: center;
                }
                .facilitator{
                    width: 300px;
                    text-align: center;
                    display: flex;
                    justify-content: center;
                }
                .price{
                    width: 100px;
                    text-align: center;
                }
                .printNum{
                    width: 100px;
                    text-align: center;
                }
            }
        }
        .invoiceInformation{
            width: 1200px;
            margin: 0 auto 20px;
            background: #fff;
            border-radius: 2px;
            .title {
                width: 100%;
                height: 56px;
                line-height: 55px;
                border-bottom: 1px solid #F0F0F0;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 24px;
                .titleLeft {
                    font-size: 16px;
                    font-weight: 500;
                    color: rgba(0, 0, 0, 0.85);
                }
                .titleRight {
                    display: flex;
                    button {
                        margin-left: 50px;
                    }
                }
            }
            .invoiceContent{
                padding: 24px 35px;
                .invoiceItem{
                    display: flex;
                    color: rgba(51, 51, 51, 0.85);
                    font-size: 14px;
                    margin-bottom: 15px;
                    align-items: center;
                    .name{
                        text-align: right;
                        min-width: 80px;
                        padding-right: 15px;
                    }
                    .content{
                        span{
                            padding-right: 30px;
                        }
                    }
                }
                .remark{
                    display: flex;
                    color: rgba(51, 51, 51, 0.85);
                    font-size: 14px;
                    margin-bottom: 15px;
                    align-items: center;
                    .name{
                        text-align: right;
                        min-width: 80px;
                        padding-right: 15px;
                    }
                }
                .invoiceInfo{
                    .invoiceItem{
                        align-items: initial;
                        .content{
                            margin-bottom: 10px;
                        }
                    }
                }
            }
        }
        .toAffirmOrder{
            width: 1200px;
            margin: 0 auto 20px;
            .subtotal{
                display: flex;
                justify-content: flex-end;
                font-size: 14px;
                color: rgba(64, 64, 64, 1);
                padding-right: 15px;
                margin-bottom: 10px;
                .content{
                    min-width: 100px;
                    text-align: right;
                }
            }
            .freight{
                display: flex;
                justify-content: space-between;
                padding-bottom: 15px;
                margin-bottom: 15px;
                border-bottom: 1px solid #ddd;
                .right{
                    display: flex;
                    justify-content: flex-end;
                    font-size: 14px;
                    color: rgba(64, 64, 64, 1);
                    padding-right: 15px;
                    .content{
                        min-width: 100px;
                        text-align: right;
                    }
                }
            }
            .total{
                display: flex;
                justify-content: flex-end;
                padding-right: 15px;
                .name{
                    color: rgba(64, 64, 64, 1);
                    font-size: 20px;
                    span{
                        font-size: 14px;
                    }
                }
                .content{
                    color: rgba(228, 36, 36, 1);
                    font-size: 20px;
                    min-width: 100px;
                    text-align: right;
                }
            }
            .buttonGroup{
                display: flex;
                justify-content: flex-end;
                margin-top: 20px;
                button{
                    margin-left: 30px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/print/printAffirmOrder.vue